export default __webpack_public_path__ + "static/media/DJI_0989.MP4.00_01_50_13.Still007.c7e536d2.jpg";